module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('ol', [_c('li', {
    attrs: {
      "id": "level1-titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-toc"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front01"
    }
  }, [_vm._v("Photo of Gronkowski Boys")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front02"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front03"
    }
  }, [_vm._v("Gronk Lineup")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-front6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/front04"
    }
  }, [_vm._v("Introduction ")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("A Star Is Born")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c02"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gordy: Papa Gronk")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c03"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evolution of Training")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c04"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gordie Jr.: Doesn’t He Know the Rest of the Family Plays Football?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c05"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mental Toughness")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dan: The Talented Workhorse")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Competition and Physical Play")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris: Brains and a Pedigree")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New Generation of Tight Ends")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rob: The Superstar")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rob Explodes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Goose: Greatness Expected")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "c13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get Gronked!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "level1-back21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0